// Exports
export default {
	"modal": "modal_fr1ES",
	"link": "link_MfgJs",
	"underlined": "underlined_YaouK"
};
